import { useState } from "react"
import { useApi, useLocation } from "utils"
import { SalesYearlyGroup, SalesYearlyItem } from "../types/SalesYearlyType"

export const YEARLY_APIS = [
  { category: "INVOICE REVENUE", code_budget: "SL_REV", key_description: "Invoice Revenue", url: "analytic-sales/sales_invoice_revenue/yearly_summary" },
  { category: "INVOICE COGS", code_budget: "SL_COGS", key_description: "Invoice COGS", url: "analytic-sales/sales_invoice_cogs/yearly_summary" },
  { category: "INVOICE PROFIT", code_budget: "SL_PROFIT", key_description: "Invoice Profit", url: "analytic-sales/sales_invoice_profit/yearly_summary" },
  { category: "INVOICE AVERAGE", code_budget: "SL_AVG", key_description: "Invoice Average", url: "analytic-sales/sales_invoice_average/yearly_summary" },
]

function createEmptyItem(location_name: string, location_id?: number | null, code_budget?: string): SalesYearlyItem {
  return {
    location_name,
    location_id: location_id ?? null,
    formula: null,
    code_budget,
    data: []
  }
}

export function useSalesYearlyList(year?: number, locationId?: number | "") {
  const api = useApi()
  const { data: locationOptions } = useLocation()
  const [data, setData] = useState<SalesYearlyGroup[]>([])
  const [loading, setLoading] = useState(false)

  const fetchData = async () => {
    if (!year) return
    setLoading(true)

    try {
      const groups = await Promise.all(
        YEARLY_APIS.map(async (apiConfig) => {
          let items: SalesYearlyItem[] = []

          if (locationId) {
            const locationName = locationOptions?.find(l => l.value === String(locationId))?.label ?? String(locationId)
            try {
              const res = await api.get(apiConfig.url, { params: { year, location_id: locationId } })
              const payload = res.data?.payload?.[0]
              items = [{
                location_name: locationName,
                location_id: locationId,
                formula: payload?.formula ?? null,
                code_budget: apiConfig.code_budget,
                data: payload?.data ?? []
              }]
            } catch {
              items = [createEmptyItem(locationName, locationId, apiConfig.code_budget)]
            }
          } else {
            const locations = locationOptions ?? []
            items = await Promise.all(
              locations.map(async (loc) => {
                try {
                  const res = await api.get(apiConfig.url, { params: { year, location_id: loc.value } })
                  const payload = res.data?.payload?.[0]
                  return {
                    location_name: loc.label,
                    location_id: Number(loc.value),
                    formula: payload?.formula ?? null,
                    code_budget: apiConfig.code_budget,
                    data: payload?.data ?? []
                  } as SalesYearlyItem
                } catch {
                  return createEmptyItem(loc.label, Number(loc.value), apiConfig.code_budget)
                }
              })
            )
          }

          return { category: apiConfig.category, code_budget: apiConfig.code_budget, key_description: apiConfig.key_description, items } as SalesYearlyGroup
        })
      )
      setData(groups)
    } catch {
      setData([])
    } finally {
      setLoading(false)
    }
  }

  return { yearlyData: data, loadingYearly: loading, refetchYearly: fetchData }
}
